export default "__VITE_ASSET__B_B6h6DF__"